import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import InputField from '../InputField';

function SupplierInputField({
  grid,
  borderradius,
  border,
  padding,
  bgcolor,
  required,
  requiredcolor,
  placeholdercolor,
  handleChange,
  companyname,
  requiredError,
}) {
  const { t } = useTranslation();

  return (
    <InputField
      name="supplier"
      grid={grid}
      required={required}
      type="text"
      placeholder={t('Supplier')}
      label={t('Supplier')}
      borderradius={borderradius}
      border={border}
      padding={padding}
      bgcolor={bgcolor}
      placeholdercolor={placeholdercolor}
      requiredcolor={requiredcolor}
      handleChange={handleChange}
      defaultValue={companyname}
      requiredError={requiredError}
    />
  );
}

SupplierInputField.propTypes = {
  grid: PropTypes.number,
  padding: PropTypes.string,
  borderradius: PropTypes.number,
  bgcolor: PropTypes.string,
  border: PropTypes.string,
  required: PropTypes.bool,
  requiredcolor: PropTypes.string,
  placeholdercolor: PropTypes.string,
  handleChange: PropTypes.func,
  companyname: PropTypes.string,
  requiredError: PropTypes.bool,
};

SupplierInputField.defaultProps = {
  grid: 12,
  padding: '',
  borderradius: 0,
  bgcolor: '#fff',
  border: '',
  required: false,
  placeholdercolor: '#efefef',
  requiredcolor: '#fff',
  companyname: '',
  requiredError: false,
};

export default SupplierInputField;
